export default {"src":"/_next/static/media/Aneurysms.3170ae87.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};